<template>
  <div id="attendanceSubject" style="padding: 0 20px; background: white" class="p-4">
    <!--<K2Row justify_content="center" class="position-relative p-4 border-bottom">-->
    <!--<K2Heading type="h5" class-name="mb-0" color="black">{{lang("Attendance by Subject")}}</K2Heading>-->
    <!--</K2Row>-->
    <iframe
      :src="
        'https://academica.etonhouse.com/Headless/Subjects/Attendances/schools/SCH201800000510/Levels/CRS202401186,CRS202401187,CRS202401188/User/' + userID
      "
      style="height: calc(100vh - 230px); width: 100%; zoom: normal; border: 0"
      width="80%"
      title="Academica"
    ></iframe>
  </div>
</template>
<script>
import Cookies from 'js-cookie'
import K2Row from '../uiComponents/k2Row/k2Row'
import K2Heading from '../uiComponents/k2Heading/k2Heading'
import uiVariable from '../config/uiVariable'
import { lang } from '../locale'

export default {
  name: 'AttendanceSubject',
  components: { K2Heading, K2Row },
  data() {
    return {
      userID: null,
      uiVariable: uiVariable,
    }
  },
  mounted() {
    this.userID = Cookies.get('userIDSession')
  },
  methods: {
    lang,
    handleBack() {
      this.$router.push('/Activity')
    },
  },
}
</script>
